import './index.css';
import {HomePage} from "./modules/home/pages/HomePage";
import {AboutOurStory} from "./modules/about/pages/AboutOurStory";
import {createHashRouter, redirect, RouterProvider,} from "react-router-dom";
import {AboutUs} from "./modules/about/pages/AboutUs";
import {AboutGovernance} from "./modules/about/pages/AboutGovernance";
import {AboutSponsorship} from "./modules/about/pages/AboutSponsorship";
import {ContactUs} from "./modules/contact/pages/ContactUs";
import {OurCompaniesPage} from "./modules/companies/pages/OurCompaniesPage";
import {LogisticPage} from "./modules/companies/pages/LogisticPage";
import {ManufacturingPage} from "./modules/companies/pages/ManufacturingPage";
import {TradingPage} from "./modules/companies/pages/TradingPage";
import {RetailPage} from "./modules/companies/pages/RetailPage";
import {PressAndMediaView} from "./modules/home/pages/PressAndMediaView";
import {RetailFashionPage} from "./modules/companies/pages/RetailFashion";
import {RetailFurniturePage} from "./modules/companies/pages/RetailFurninture";
import {AboutCareerPage} from "./modules/about/pages/AboutCareerPage";
import {BeveragePage} from "./modules/companies/pages/BeveragePage";
import {isUrlPathVisitAllowed} from "./modules/core/services/firebase.mjs";


function pathVisitLoader(path) {
    return async () => {
        const isAllowed = await isUrlPathVisitAllowed(path);
        if (!isAllowed) {
            throw redirect("/");
        }
        return null;
    };
}

function route(path, element) {
    return {
        path,
        element,
        loader: pathVisitLoader(path),
    };
}

const companiesRoutes = [
    {
        path: "companies/logistics",
        element: <LogisticPage/>,
        loader: pathVisitLoader("companies/logistics"),
    },
    {
        path: "companies/manufacturing",
        element: <ManufacturingPage/>,
        loader: pathVisitLoader("companies/manufacturing"),
    },
    {
        path: "companies/beverage",
        element: <BeveragePage/>,
        loader: pathVisitLoader("companies/beverage"),
    },
    {
        path: "companies/trading",
        element: <TradingPage/>,
        loader: pathVisitLoader("companies/trading"),
    },
    {
        path: "companies/retail",
        element: <RetailPage/>,
        loader: pathVisitLoader("companies/retail"),
    },
    {
        path: "companies/retail/fashion",
        element: <RetailFashionPage/>,
        loader: pathVisitLoader("companies/retail/fashion"),
    },
    {
        path: "companies/retail/furniture",
        element: <RetailFurniturePage/>,
        loader: pathVisitLoader("companies/retail/furniture"),
    },

    {
        path: "logistics",
        element: <LogisticPage/>,
        loader: pathVisitLoader("logistics"),
    },
    {
        path: "manufacturing",
        element: <ManufacturingPage/>,
        loader: pathVisitLoader("manufacturing"),
    },
    {
        path: "beverage",
        element: <BeveragePage/>,
        loader: pathVisitLoader("beverage"),
    },
    {
        path: "trading",
        element: <TradingPage/>,
        loader: pathVisitLoader("trading"),
    },
    {
        path: "retail",
        element: <RetailPage/>,
        loader: pathVisitLoader("retail"),
    },
    {
        path: "retail/fashion",
        element: <RetailFashionPage/>,
        loader: pathVisitLoader("retail/fashion"),
    },
    {
        path: "retail/furniture",
        element: <RetailFurniturePage/>,
        loader: pathVisitLoader("retail/furniture"),
    },
]
const router = createHashRouter([
    {
        path: "/",
        element: <HomePage/>,
    },
    route("/updates", <PressAndMediaView/>),
    route("about", <AboutOurStory/>),
    route("about_us", <AboutUs/>),
    route("about_governance", <AboutGovernance/>),
    route("about_sponsorship", <AboutSponsorship/>),
    route("about_career", <AboutCareerPage/>),
    route("companies", <OurCompaniesPage/>),
    ...companiesRoutes,
    route("products", <OurCompaniesPage/>),
    route("contacts", <ContactUs/>),
    {
        path: '*',
        element: <HomePage/>
    }
]);

function App() {
    return (
        <RouterProvider router={router}/>
    );
}

export default App;
